import { Vue, Component, Watch } from 'vue-property-decorator'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppTextField from '@/components/AppTextField.vue'
import AppFormItem from '@/components/AppFormItem.vue'
import AppListSelector from '@/components/AppListSelector.vue'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import AppSelector from '@/components/AppSelector.vue'
import { OrderModel } from '@/interfaces/order'
import { updateOrderAddress, findOrder, findSchools } from './gql'

import { TypedGqlError } from '@/interfaces/error'
import AppDialog from '@/components/AppDialog.vue'

Component.registerHooks([
  'beforeRouteLeave'
])

@Component({
  components: {
    AppBreadcrumbs,
    AppTextField,
    AppFormItem,
    AppListSelector,
    AppSimpleDistrictSelector,
    AppSelector,
    AppDialog
  }
})
export default class Editgoods extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '订单管理'
    },
    {
      text: '订单',
      to: { name: 'OrderList' }
    }
  ]

  order: OrderModel | null = null
  orderInput: any = { area: null, schoolIdx: -1, schoolName: '', year: '', className: '', realName: '', phone: '' }

  // 判断新建还是编辑
  isEdit = false
  activeTab = 0
  orderId = ''
  editOrderName = ''
  hint = {
    text: '',
    color: ''
  }

  disabledActions = false

  isLeave = false
  schoolOptions: {id: number; label: string}[] = []

  @Watch('orderInput.area', { deep: true, immediate: true })
  onAreaChange (val: any) {
    if (!val) {
      this.hint.text = '请选择地区'
      this.hint.color = 'red'
    } else {
      this.hint = {
        text: '',
        color: ''
      }
      this.getSchoolOptions()
    }
  }

  // mounted
  async mounted () {
    // 判断是否为编辑
    const type = sessionStorage.getItem('type')
    if (type) {
      await this.initData(type)
    } else {
      sessionStorage.setItem('type', this.$route.params.type)
      await this.initData(this.$route.params.type)
    }
  }

  // 初始化数据
  async initData (type: string) {
    if (type === 'new') {
      // 新建
      this.isEdit = false
      this.breadcrumbs.push({ text: '添加学校' })
    } else {
      // 编辑
      this.isEdit = true
      const { id } = this.$route.params
      this.orderId = id
      await this.getOrderById()
    }
  }

  // 查询by id
  async getOrderById () {
    try {
      const result = await this.$apollo.query({
        query: findOrder,
        variables: {
          orderId: +this.orderId
        }
      })
      if (result) {
        this.order = result.data.findOrder
        const { mailingAddress, orderNumber, area } = result.data.findOrder
        const addrArr = mailingAddress.split('-')
        const schoolName = addrArr[1]
        this.orderInput = {
          area,
          schoolName: schoolName,
          year: addrArr[2].substr(0, 4),
          className: addrArr[3].substr(0, 1),
          realName: addrArr[4],
          phone: addrArr[5]
        }
        this.breadcrumbs = [
          {
            text: '订单管理'
          },
          {
            text: '订单',
            to: { name: 'OrderList' }
          }
        ]
        this.breadcrumbs.push({ text: `${orderNumber}` })
      }
    } catch (error) {
      const typedError = error as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 获取经销商option
  async getSchoolOptions () {
    if (!this.orderInput.area) {
      this.schoolOptions = []
      return
    }
    try {
      const result = await this.$apollo.query({
        query: findSchools,
        variables: {
          paging: {
            skip: 0,
            take: 10000
          },
          where: {
            areaId: +this.orderInput.area.id
          }
        }
      })
      if (result.data.findSchools) {
        this.schoolOptions = result.data.findSchools.schools.map((option: any) => {
          return {
            id: +option.id,
            label: option.name
          }
        })
        this.orderInput.schoolIdx = this.schoolOptions.findIndex(item => item.id === this.order?.schoolId)
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 清空form
  clearForm () {
    this.orderInput = {
      area: null,
      name: '',
      dealerArea: null,
      dealerIds: []
    }
  }

  async submitBasic () {
    await this.editOrderRequest()
  }

  // 编辑学校request
  async editOrderRequest () {
    if (this.validateForm('form')) {
      const { area, schoolIdx, year, className, realName, phone } = this.orderInput

      const school = this.schoolOptions[schoolIdx]

      const mailingAddress = `${area.mergerName}-${school.label}-${year}年入学-${className}班-${realName}-${phone}`

      try {
        const result = await this.$apollo.mutate({
          mutation: updateOrderAddress,
          variables: {
            orderId: +this.orderId,
            mailingAddress,
            schoolId: +school.id,
            areaId: +area.id
          }
        })
        if (result) {
          showNotification({
            msg: '更新订单地址成功！',
            type: SnackType.Success
          })

          this.isEdit = true
          sessionStorage.setItem('type', 'edit')
          this.disabledActions = true
          this.$router.go(-1)
        } else {
          showNotification({
            msg: '更新订单地址失败！',
            type: SnackType.Error
          })
        }
      } catch (e) {
        const typedError = e as TypedGqlError
        showErrors(typedError.graphQLErrors)
      }
    }
  }

  // 表单重置验证
  resetValidation (form: string) {
    (
      this.$refs[form] as Vue & { resetValidation: () => void }
    ).resetValidation()
  }

  // 表单验证
  validateForm (form: string) {
    return (this.$refs[form] as Vue & { validate: () => boolean }).validate()
  }

  saveDialog = {
    title: '已认真核对并更新该订单的收货地址？',
    show: false,
    text: ''
  }

  beforeDestroy () {
    if (!this.disabledActions) {
      this.saveDialog.show = true
    }
    sessionStorage.removeItem('type')
  }

  async beforeRouteLeave (to: any, from: any, next: any) {
    if (!this.disabledActions) {
      const res = confirm('页面修改尚未保存，是否确定要离开？')
      next(res)
    } else {
      next()
    }
  }
}
